/**
 * Orders Settings Modal Wrapper (Factory Pattern)
 * 
 * Routes to destination-specific order settings modal.
 * - destination='netsuite' → NetSuiteOrdersSettingsModal
 * - destination='sage' → SageOrdersSettingsModal
 * - future: destination='magento' → MagentoOrdersSettingsModal
 * 
 * This is the UI equivalent of backend ProviderFactory!
 */

import React from 'react';
import { NetSuiteOrdersSettingsModal } from './NetSuiteOrdersSettingsModal';
import { SageOrdersSettingsModal } from './SageOrdersSettingsModal';

export function OrdersSettingsModalWrapper({ destination, source, ...props }) {
  // Factory method - pick modal based on destination
  const getModalComponent = (dest) => {
    switch(dest?.toLowerCase()) {
      case 'netsuite':
        return NetSuiteOrdersSettingsModal;
      case 'sage':
        return SageOrdersSettingsModal;
      default:
        return null;
    }
  };
  
  const ModalComponent = getModalComponent(destination);
  
  // No modal for this destination
  if (!ModalComponent) {
    return null;
  }
  
  // Render destination-specific modal
  return <ModalComponent source={source} {...props} />;
}

